import type { RootState } from "types/redux";

export const getVisualMediaPlayerFile = (state: RootState) => state.domains.visualMediaPlayer.file;
